import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '@/views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
  },
  {
    path: '/ntf',
    name: 'ntf',
    component: () => import('@/views/ntf/HomeView.vue'),
  },
  {
    path: '/ntf/luffy-nft',
    name: 'LuffyNFT',
    component: () => import('@/views/ntf/LuffyNFT.vue'),
  },
  {
    path: '/ntf/my-nft',
    name: 'MyNFT',
    component: () => import('@/views/ntf/MyNFT.vue'),
  },
  {
    path: '/ntf/nami-nft',
    name: 'NamiNFT',
    component: () => import('@/views/ntf/NamiNFT.vue'),
  },
  {
    path: '/ntf/girl-nft',
    name: 'GirlNFT',
    component: () => import('@/views/ntf/GirlNFT.vue'),
  },
  {
    path: '/medal',
    name: 'medal',
    component: () => import('@/views/RightMedal.vue'),
  },
  {
    path: '/ok-lp',
    name: 'OK-LP',
    component: () => import('@/views/OK-LP.vue'),
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.NODE_ENV === 'development' ? '/' : '/',
  routes,
})

export default router
